import { render, staticRenderFns } from "./AgentIcon.vue?vue&type=template&id=9aac9b1a&scoped=true&"
import script from "./AgentIcon.vue?vue&type=script&lang=js&"
export * from "./AgentIcon.vue?vue&type=script&lang=js&"
import style0 from "./AgentIcon.vue?vue&type=style&index=0&id=9aac9b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aac9b1a",
  null
  
)

export default component.exports